import { render } from "./VoteCardItemControl.vue?vue&type=template&id=121c2ad4"
import script from "./VoteCardItemControl.vue?vue&type=script&lang=js"
export * from "./VoteCardItemControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__